import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import {STATION_GROUP_EMPLOYEES} from './stationGroupEmployees.type';
import type FILTERS from '../../../../../common/filters.type';

import stationGroupEmployeesServices from './stationGroupEmployeesServices';

const initialState = {
  isLoading: false,
  groupEmployeesList: {
    totalDataCount: 0,
    page_size: 10,
    page_number: 1,
    sort_by: 'name',
    ascending: true,
    search: '',
    pageData: [] as STATION_GROUP_EMPLOYEES[],
  },
};

export const stationGroupEmployeesList = createAsyncThunk(
  'stationGroupEmployeesList',
  async (payload: {groupId: number; filters?: FILTERS}, thunkAPI) => {
    try {
      const data: AxiosResponse = await stationGroupEmployeesServices.stationGroupEmployeeList(
        payload,
      );

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const updateStationGroupEmployees = createAsyncThunk(
  'updateStationGroupEmployees',
  async (payload: {groupId: number; employee_ids: number[]}, thunkAPI) => {
    try {
      const data: AxiosResponse = await stationGroupEmployeesServices.updateStationGroupEmployee(
        payload,
      );

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const stationGroupEmployeesSlice = createSlice({
  name: 'stationGroupEmployeesSlice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    pageNumberChange(state, action: PayloadAction<number>) {
      state.groupEmployeesList.page_number = action.payload;
    },
    pageSizeChange(state, action: PayloadAction<number>) {
      state.groupEmployeesList.page_number = 1;
      state.groupEmployeesList.page_size = action.payload;
    },
    searchBy(state, action: PayloadAction<string>) {
      state.groupEmployeesList.page_number = 1;
      state.groupEmployeesList.search = action.payload;
    },
    sortBy(state, action: PayloadAction<{ascending: boolean; sortBy: string}>) {
      state.groupEmployeesList.ascending = action.payload.ascending;
      state.groupEmployeesList.sort_by = action.payload.sortBy;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(stationGroupEmployeesList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(stationGroupEmployeesList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.groupEmployeesList = action.payload.data;
    });
    builder.addCase(stationGroupEmployeesList.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
    builder.addCase(updateStationGroupEmployees.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateStationGroupEmployees.fulfilled, (state) => {
      state.isLoading = false;
      message.success('Employees added successful in Station group');
    });
    builder.addCase(updateStationGroupEmployees.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});
export const {pageNumberChange, pageSizeChange, searchBy, sortBy} =
  stationGroupEmployeesSlice.actions;

export default stationGroupEmployeesSlice.reducer;
